// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3q1hx","head":"Table_head__3aWxx","col":"Table_col__1DeOa"};